import { render } from "./NewLeaveApprove.vue?vue&type=template&id=4f5e8955"
import script from "./NewLeaveApprove.vue?vue&type=script&lang=js"
export * from "./NewLeaveApprove.vue?vue&type=script&lang=js"

import "./NewLeaveApprove.vue?vue&type=style&index=0&id=4f5e8955&lang=less"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__